// extracted by mini-css-extract-plugin
export var activeFilterButton = "_ne-c";
export var backButton = "_ne-4";
export var backIcon = "_ne-5";
export var chevronShortcut = "_ne-6";
export var container = "_ne-1";
export var editor = "_ne-8";
export var editorWrapper = "_ne-7";
export var prefix = "_ne-2";
export var searchIcon = "_ne-3";
export var suffix = "_ne-9";
export var suffixContent = "_ne-a";
export var suffixText = "_ne-b";
export var wrapper = "_ne-0";